import { type ComponentType } from 'react';

import AkInlineDialog from '@atlaskit/inline-dialog/inline-dialog';
import { type InlineDialogProps as AkInlineDialogProps } from '@atlaskit/inline-dialog/types';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ToggleableChoreographerUtilities,
} from '../../types';
import { wrapToggleableComponentForChoreographer } from '../utils';

export const InlineDialog: {
	({
		shouldBeChoreographed,
		withChoreographedToggle,
		...props
	}: AkInlineDialogProps &
		ToggleableChoreographerUtilities &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
		}): React.JSX.Element;
	displayName: string;
} = wrapToggleableComponentForChoreographer<AkInlineDialogProps>(
	AkInlineDialog as ComponentType<AkInlineDialogProps>,
	'isOpen',
);
